module.exports = __webpack_public_path__ + "static/InterFaceThin-Italic-a60606d25fe5451db0566f8a639255aa.woff2";